module.exports = __webpack_public_path__ + "static/img/CLUB.b1c4d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/CLUB.png
// module id = Takl
// module chunks = 1